<div [loadingOverlay]="isLoading" *ngIf="!!customerUser" class="modal-content">
  <div class="modal-header justify-content-center">
    <h5 class="modal-title">{{isNewUser() ? 'Add' : 'Edit'}} Customer Contact</h5>
  </div>
  <div class="modal-body pb-5">
    <div class="row mt-3">
      <div class="col-md-10">
        <div [formGroup]="customerUserForm">
          <div class="form-group row">
            <label class="col-md-4 col-form-label">First Name</label>
            <div class="col-md-8">
              <input type="text" class="form-control" formControlName="FirstName" lpValidationMsg/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label">Last Name</label>
            <div class="col-md-8">
              <input type="text" class="form-control" formControlName="LastName" lpValidationMsg/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label">Email/Username</label>
            <div class="col-md-8">
              <input type="text" class="form-control" formControlName="Username" lpValidationMsg/>
            </div>
          </div>
          <ng-container *ngIf="!isDashboardOnlyUser()">
            <div class="form-group row">
              <label class="col-md-4 col-form-label">Email Recipient Type</label>
              <div class="col-md-8">
                <ng-select formControlName="EmailRecipientType" [items]="emailRecipientOptions" placeholder="Select email recipient type"
                  [clearable]="false" [searchable]="false">
                  <ng-template ng-label-tmp let-item="item">
                    {{ item | emailRecipientType }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item | emailRecipientType }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="!isDashboardOnlyUser()">
          <ng-container *ngFor="let phoneNumberForm of phoneNumbers.controls">
            <div class="form-group row" [formGroup]="phoneNumberForm">
              <label class="col-md-4 col-form-label">{{phoneNumberForm.get('Primary').value ? 'Phone' : 'Alt'}}</label>
              <div class="col-md-8">
                <input formControlName="PhoneNumber" lpValidationMsg type="text" class="form-control"/>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="form-group row" *ngIf="partner.AllowsTextMessaging && !isDashboardOnlyUser()">
          <label class="col-md-4 col-form-label">Can Receive Texts</label>
          <div class="col-md-8">
            <span style="width:141px;">
              <shared-components-customchoice [value]="customerUserForm.get('CanReceiveTextMessages').value" (valueChange)="onCanReceiveTextMessagesValueChange($event)" [disable]="!canConfigureTextMessaging()">
              </shared-components-customchoice>
            </span>
            <app-components-helptext [key]="'CustomerUser_CanReceiveTextMessages'"></app-components-helptext>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button (click)="dismiss()" type="submit" class="btn btn-primary">
      <i class="fa fa-times"></i>
      Cancel
    </button>
    <button (click)="save()" type="submit" class="btn btn-success">
      <i class="fa fa-save"></i>
      Save
    </button>
  </div>
</div>
